module.exports = __webpack_public_path__ + "assets/images/privateSegments-1c9028bcba9fcadc4671c19080ae964e.png";